import React, { useState, useEffect } from "react";
import moment from 'moment';
import { Link } from "react-router-dom";

const Pickupdrop = () => {
    let localStoragesData = JSON.parse(localStorage.getItem('cab_listing')) || {};
    let TimeDate = moment(localStoragesData.pickup_date);
    let dropDate = moment(localStoragesData.drop_date)

    const helper_fun_camle_case = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return (
        <>
            <div className="pickdropup sidefaresum my-4">
                <h4>Pick-up and Drop-off</h4>

                <ul className="to-from">
                    <li>
                        <p>
                            {localStoragesData.trip_type === 'airport' && localStoragesData.pickup_drop === 'pickup'
                                ? localStoragesData.to_city
                                : localStoragesData.from_city}
                        </p>
                        <span>
                            {TimeDate.format('dddd')}, {TimeDate.date()} {TimeDate.format('MMMM')} {TimeDate.format('YYYY')},
                            {localStoragesData.pickup_time}
                        </span>
                    </li>
                    <li>
                        {localStoragesData?.trip_type === 'airport' ? (
                            // Airport pickup/drop logic
                            <p>
                                {localStoragesData.pickup_drop === 'pickup'
                                    ? localStoragesData.from_city
                                    : localStoragesData.to_city}
                            </p>
                        ) : localStoragesData?.trip_type === 'outstation'
                            && localStoragesData.travel_routes.length > 0 ? (
                            // Outstation with multiple routes
                            localStoragesData.travel_routes.map((value, index) => (
                                <p key={index}>{value.cityInput}</p>
                            ))
                        ) : localStoragesData?.trip_type === 'local' ? (
                            // Local trip
                            <p>{localStoragesData?.package} | {localStoragesData?.from_city}, India</p>
                        ) : (
                            // Default (oneway)
                            <p>{localStoragesData.to_city}</p>
                        )}
                        {/* Date display logic */}
                        <span>
                            {localStoragesData.trip_type === 'outstation'
                                ? dropDate.format('dddd')
                                : TimeDate.format('dddd')}
                        </span>
                    </li>
                </ul>
                <div className="bkngtype">
                    <h4>Booking Type</h4>
                    <span>{helper_fun_camle_case(localStoragesData.trip_type) === 'Outstation' ?
                        'Outstation (Roundtrip)' :
                        helper_fun_camle_case(localStoragesData.trip_type) === 'Oneway' ?
                            'Outstation (Oneway)' :
                            helper_fun_camle_case(localStoragesData.trip_type) === 'Local' ?
                                `Local ( ${localStoragesData.package} )` :
                                helper_fun_camle_case(localStoragesData.trip_type) === 'Airport' ?
                                    `Airport ( ${helper_fun_camle_case(localStoragesData.pickup_drop)} )` : ''
                    }</span>
                </div>
                <div className="modfy">
                    <Link to={'/'} className="sitebtn">Modify</Link>
                </div>
            </div>

        </>
    )
}
export default Pickupdrop;
